/**
 * @author Mihail Sablin <mihail@webprogrammist.com>
 * @copyright Copyright (c) 2023, Mihail Sablin
 * @licence http://www.opensource.org/licenses/mit-license.php MIT licence
 */
;
"use strict";

const
	$document = $(document),
	$window = $(window);
const Y_METRIKA_ID = '100123662';

window.yii.getIsGuest = () => {
	return document.querySelector('meta[name="auth"]')?.getAttribute('content') !== '1';
};
window.yii.getIsAuth = () => {
	return document.querySelector('meta[name="auth"]')?.getAttribute('content') === '1';
};
window.yii.getThemeUrl = () => {
	return document.querySelector('meta[name="theme-url"]')?.getAttribute('content');
};
window.yii.getAssetUrl = (asset) => {
	return yii.getThemeUrl() + '/' + asset.replace(/^\//, '');
};

function formatBytes(bytes, unit = 'kilobyte', language = 'ru') {
	return new Intl.NumberFormat(language, {
		style: 'unit',
		unit: unit,
	}).format(bytes);
}

function debounce(func, timeout = 300) {
	let timer;
	return (...args) => {
		clearTimeout(timer);
		if(timeout) {
			timer = setTimeout(() => {
				func.apply(this, args);
			}, timeout);
		}
	};
}

/**
 * Template looks like ${args.title} - args is important!
 * @param {String} template
 * @param {Boolean} replace
 * @returns {function(Object): string}
 */
function prepareTemplate(template, replace = true) {
	if (replace) {
		template = template.replaceAll('\[\[', '\$\{args\.').replaceAll('\]\]', '\}');
	}
	return (args) => {
		return eval('`' + template + '`');
	};
}

/**
 * Достижение цели в Яндекс.Метрика
 * @param {String} goal
 * @param args
 */
function reachGoal(goal, ...args) {
	echo(Y_METRIKA_ID, 'reachGoal', goal, ...args);
	if (typeof ym !== 'undefined') {
		try {
			ym(Y_METRIKA_ID, 'reachGoal', goal, ...args);
		} catch (e) {
			console.error(e);
		}
	}
}

function echo(...args) {
	console && console.log(...args);
}
